import { getSiblingElements } from '@s1/core/utilities';

const hamburger = document.querySelectorAll('.hamburger');
const popout = document.querySelector('.popout');
const popoutClose = document.querySelector('.popout__close');
const overlay = document.querySelector('.overlay');
const searchToggle = document.querySelectorAll('.search-toggle');
const footerHamburger = document.querySelector('.footer .hamburger');
const footerSearchToggle = document.querySelector('.footer .search-toggle');
const menuWithChildren = document.querySelectorAll('.nav__item--has-children');
const popoutmenuWithChildren = document.querySelectorAll('.popout-nav__item--has-children');

// Toggle overlay
function toggleOverlay() {
  if (overlay) {
    overlay.classList.toggle('overlay--visible');
  }
}

// Toggle popout
function togglePopout() {
  if (popout) {
    popout.classList.toggle('popout--visible');
  }
}

// Handle click events outside active subnav menu.
function handleClickOutsideActiveSubNav(event) {
  const subNavClicked = event.target.matches('.subnav') || event.target.matches('.subnav *');
  const toggleClicked = event.target.matches('.nav__toggle');
  if (!subNavClicked && !toggleClicked) {
    const subnavs = document.querySelectorAll('.subnav--visible');
    const toggles = document.querySelectorAll('.nav__toggle--active');
    subnavs.forEach((subnav) => {
      subnav.classList.remove('subnav--visible');
    });
    toggles.forEach((toggle) => {
      toggle.classList.remove('nav__toggle--active');
    });
    document.removeEventListener('click', handleClickOutsideActiveSubNav);
  }
}

// Toggle subnav menu
function toggleSubnav(event) {
  const toggle = event.target;
  const navItem = event.target.parentNode;
  const subnav = event.target.parentNode.querySelector('.subnav');
  const siblingNavItems = getSiblingElements(navItem, 'nav__item--has-children');

  siblingNavItems.forEach((siblingNavItem) => {
    const siblingNavToggle = siblingNavItem.querySelector('.nav__toggle');
    siblingNavItem.querySelector('.subnav').classList.remove('subnav--visible');
    siblingNavToggle.classList.remove('nav__toggle--active');
  });
  document.removeEventListener('click', handleClickOutsideActiveSubNav);

  toggle.classList.toggle('nav__toggle--active');
  if (subnav) {
    subnav.classList.toggle('subnav--visible');
    if (subnav.classList.contains('subnav--visible')) {
      document.addEventListener('click', handleClickOutsideActiveSubNav);
    }
  }
}

function togglePopoutSubnav(event) {
  event.target.classList.toggle('popout-nav__toggle--active');
  const subnav = event.target.parentNode.querySelector('.popout-subnav');
  if (subnav) subnav.classList.toggle('popout-subnav--visible');
}

// Toggle popout close button
function togglePopoutClose() {
  if (popoutClose) {
    popoutClose.classList.toggle('popout__close--active');
    if (popoutClose.classList.contains('popout__close--active')) {
      popoutClose.setAttribute('aria-label', 'Hide Menu');
    } else {
      popoutClose.setAttribute('aria-label', 'Show Menu');
    }
  }
}

// Toggle hamburger(s)
function toggleHamburger() {
  hamburger.forEach((element) => {
    element.classList.toggle('hamburger--active');
    if (element.classList.contains('hamburger--active')) {
      element.setAttribute('aria-label', 'Hide Menu');
    } else {
      element.setAttribute('aria-label', 'Show Menu');
    }
  });
}

// Toggle search button
function toggleSearch() {
  searchToggle.forEach((element) => {
    element.classList.toggle('search-toggle--active');
    if (element.classList.contains('search-toggle--active')) {
      element.setAttribute('aria-label', 'Hide Search');
    } else {
      element.setAttribute('aria-label', 'Show Search');
    }
  });
}

function nav() {
  // Clicking on hamburger(s)
  hamburger.forEach((element) => {
    element.addEventListener('click', () => {
      toggleSearch();
      toggleHamburger();
      togglePopoutClose();
      togglePopout();
      toggleOverlay();
    });
  });

  // clicking on a list item with --has-children
  menuWithChildren.forEach((element) => {
    const button = element.querySelector('button');
    button.addEventListener('click', (event) => {
      toggleSubnav(event);
    });

    // add custom class to trigger subnav as well
    const triggerSubNav = element.querySelector('.trigger-subnav > a');
    if (triggerSubNav) {
      triggerSubNav.addEventListener('click', (event) => {
        // mask as a button click (default functionality)
        // so classes that handle animations are applied properly
        button.click();
        event.preventDefault();
      });
    }
  });

  popoutmenuWithChildren.forEach((element) => {
    const button = element.querySelector('button');
    button.addEventListener('click', (event) => {
      togglePopoutSubnav(event);
    });
  });

  // Prevent popout transition on page load
  if (popout) {
    setTimeout(() => {
      popout.classList.add('popout--transition');
    }, 500);
  }

  // Clicking on popout close button
  if (popoutClose) {
    popoutClose.addEventListener('click', () => {
      toggleSearch();
      toggleHamburger();
      togglePopoutClose();
      togglePopout();
      toggleOverlay();
    });
  }

  // Clicking on the overlay
  if (overlay) {
    overlay.addEventListener('click', () => {
      toggleSearch();
      toggleHamburger();
      togglePopoutClose();
      togglePopout();
      toggleOverlay();
    });
  }

  // Clicking on search toggle
  searchToggle.forEach((element) => {
    element.addEventListener('click', () => {
      toggleSearch();
      toggleHamburger();
      togglePopoutClose();
      togglePopout();
      toggleOverlay();

      // Focus search switcher--site
      setTimeout(() => {
        const searchSwitcherInput = document.querySelector('.search-switcher__text-input--site');
        if (searchSwitcherInput) {
          searchSwitcherInput.focus();
        }
      }, 50); // account for css visibility transiiton
    });
  });

  // Add additional class to hamburger in footer
  if (footerHamburger) {
    footerHamburger.classList.add('hamburger--footer');
  }

  // Add additional class to search-toggle in footer
  if (footerSearchToggle) {
    footerSearchToggle.classList.add('search-toggle--footer');
  }

  // swap between site and web search
  const searchWebButton = document.querySelector('.search-switcher__button--web');
  const searchSiteButton = document.querySelector('.search-switcher__button--site');
  const searchSiteInput = document.querySelector('.search-switcher__form--site');
  const searchWebInput = document.querySelector('.search-switcher__form--web');
  if (searchWebButton && searchSiteButton && searchSiteInput && searchWebInput) {
    searchWebButton.addEventListener('click', () => {
      searchWebButton.classList.toggle('search-switcher__button--active');
      searchSiteButton.classList.toggle('search-switcher__button--active');
      searchWebInput.style.display = 'flex';
      searchSiteInput.style.display = 'none';

      // Focus search switcher--web
      const input = searchWebInput.querySelector('.search-switcher__text-input');
      if (input) {
        input.focus();
      }
    });

    searchSiteButton.addEventListener('click', () => {
      searchWebButton.classList.toggle('search-switcher__button--active');
      searchSiteButton.classList.toggle('search-switcher__button--active');
      searchWebInput.style.display = 'none';
      searchSiteInput.style.display = 'flex';

      // Focus search switcher--site
      const input = searchSiteInput.querySelector('.search-switcher__text-input');
      if (input) {
        input.focus();
      }
    });
  }
}

export default nav;
